// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2_YhQ","buttons":"Footer_buttons__11eBv"};